import { render, staticRenderFns } from "./rulesDiv.vue?vue&type=template&id=d89a83c6&"
import script from "./rulesDiv.vue?vue&type=script&lang=ts&"
export * from "./rulesDiv.vue?vue&type=script&lang=ts&"
import style0 from "./rulesDiv.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports